import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SignupBg from "../Images/SignupBg.png";
import logo from "../Images/orra_logo_reszie.png";
import { Benefits } from "../Components/singup/Benefits";
import Cal, { getCalApi } from "@calcom/embed-react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "../index.css";
import "../App.css";

const ENV = process.env.REACT_APP_ENV;

const CalComSkeleton = () => {
  return (
    <div className="w-full ">
      {/* Left sidebar with logo and event info */}
      <div className="flex mb-6 bg-white p-4">
        <div className="w-1/4 pr-4 border-r border-gray-200">
          <div className="flex items-center mb-3">
            <Skeleton circle width={36} height={36} />
            <div className="ml-2">
              <Skeleton width={120} height={16} />
            </div>
          </div>
          <div className="mb-3">
            <Skeleton width={180} height={22} />
            <Skeleton width={160} height={22} className="mt-1" />
          </div>
          <div className="mb-4">
            <Skeleton width={200} height={16} />
            <Skeleton width={170} height={16} className="mt-1" />
            <Skeleton width={190} height={16} className="mt-1" />
          </div>
          <div className="mb-3">
            <Skeleton width={140} height={16} />
            <Skeleton width={180} height={16} className="mt-1" />
            <Skeleton width={170} height={16} className="mt-1" />
            <Skeleton width={150} height={16} className="mt-1" />
          </div>
          <div>
            <div className="flex items-center mt-3">
              <div className="flex items-center mt-4">
                <Skeleton circle width={20} height={20} />
                <Skeleton width={50} height={16} className="ml-2" />
              </div>
              <Skeleton circle width={20} height={20} />
              <Skeleton width={120} height={16} className="ml-2" />
            </div>
          </div>
        </div>

        {/* Main calendar content */}
        <div className="w-2/4 pl-4 pr-4 border-r border-gray-200">
          {/* Month header */}
          <div className="flex justify-between items-center mb-6">
            <div className="flex items-center">
              <Skeleton width={120} height={24} />
            </div>
            <div className="flex space-x-4">
              <div className="flex space-x-2">
                <Skeleton width={24} height={24} />
                <Skeleton width={24} height={24} />
              </div>
            </div>
          </div>

          {/* Selected day with timezone */}
          <div className="flex justify-between items-center mb-4">
            <Skeleton width={100} height={24} />
            <div className="flex">
              <Skeleton
                width={60}
                height={32}
                style={{ borderRadius: "16px 0 0 16px" }}
              />
              <Skeleton
                width={60}
                height={32}
                style={{ borderRadius: "0 16px 16px 0" }}
              />
            </div>
          </div>

          {/* Weekday header */}
          <div className="grid grid-cols-7 gap-1 mb-2">
            {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((day, i) => (
              <div key={`weekday-${i}`} className="flex justify-center">
                <Skeleton width={32} height={20} />
              </div>
            ))}
          </div>

          {/* Calendar grid */}
          <div className="grid grid-cols-7 gap-1 mb-6 p-4">
            {Array(35)
              .fill(0)
              .map((_, i) => {
                // Make a special skeleton for the 10th day (index 9) that looks selected
                const isHighlighted = i === 9;
                return (
                  <div
                    key={`day-${i}`}
                    className={`h-12 flex items-center justify-center`}
                  >
                    {isHighlighted ? (
                      <div className="w-12 h-12 rounded-md bg-blue-800 flex items-center justify-center text-white">
                        <span></span>
                      </div>
                    ) : (
                      <Skeleton
                        width={32}
                        height={32}
                        style={{ borderRadius: "4px" }}
                      />
                    )}
                  </div>
                );
              })}
          </div>

          {/* Time slots */}
        </div>
        <div className="w-1/4 pl-4">
        <div className="flex justify-between items-center mb-3">
          <Skeleton width={120} height={24}  />
          <div className="flex items-center gap-1">
          <Skeleton width={20} height={20} />
          <Skeleton width={20} height={20} />
          </div>

        </div>
          {/* 4:00pm slot */}
          <div className=" flex flex-col gap-4  p-4">
            <div className="flex justify-between items-center rounded-lg border border-gray-300 p-4">
              <div className="flex items-center ">
                <div className="h-3 w-3 rounded-full bg-green-400 mr-2"></div>
                <Skeleton width={100} height={20} />
              </div>
            </div>
            <div className="flex justify-between items-center rounded-lg border border-gray-300 p-4">
              <div className="flex items-center ">
                <div className="h-3 w-3 rounded-full bg-green-400 mr-2"></div>
                <Skeleton width={100} height={20} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const CalComComponent = () => {
  const [isCalLoaded, setIsCalLoaded] = useState(false);

  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: "candidature-orra-academy" });
      cal("ui", {
        cssVarsPerTheme: {
          light: { "cal-brand": "#192a6d" },
          dark: { "cal-brand": "#fafafa" },
        },
        hideEventTypeDetails: false,
        layout: "month_view",
      });
    })();
  }, []);

  // Handle Cal.com loading state
  useEffect(() => {
    // Setup a timeout as a fallback in case onReady doesn't fire
    const fallbackTimer = setTimeout(() => {
      if (!isCalLoaded) {
        console.log("Cal fallback timer triggered");
        setIsCalLoaded(true);
      }
    }, 5000);

    return () => clearTimeout(fallbackTimer);
  }, [isCalLoaded]);

  const handleCalReady = () => {
    console.log("Cal is ready");
    setIsCalLoaded(true);
  };

  return (
    <div className="w-full h-full flex flex-col">
      <h1 className="text-start font-bold text-2xl mb-2 text-gray-300">
        Réservez votre session
      </h1>
      <div className="w-full h-full bg-[#ffffff12] rounded-lg p-4">
        {/* Show skeleton loader while Cal.com is loading */}
        {!isCalLoaded && <CalComSkeleton />}

        {/* Actual Cal.com component */}
        <div className={!isCalLoaded ? "hidden" : "block"}>
          <Cal
            namespace="candidature-orra-academy"
            calLink="team/orra-academy/candidature-orra-academy"
            config={{
              theme: "auto",
              hideEventTypeDetails: false,
              layout: "month_view",
            }}
            onReady={handleCalReady}
          />
        </div>
      </div>
      <p className="mt-2 text-center text-sm text-gray-600">
        Déjà inscrit?{" "}
        <Link
          to="/login"
          className="font-medium text-[#284bff] hover:text-indigo-500"
        >
          Connexion
        </Link>
      </p>
    </div>
  );
};

const Signup = () => {
  return (
    <div
      className="min-h-screen h-fit w-full flex flex-col bg-[#00061E] bg-cover bg-no-repeat justify-center items-center"
      style={{ backgroundImage: `url(${SignupBg})` }}
    >
      <div className="flex items-center gap-2 my-4">
        <img src={logo} width={180} height={95} alt="Logo" />
        {ENV === "staging" && (
          <div className="text-sm text-gray-500">{ENV}</div>
        )}
      </div>

      <div className="w-[90%] lg:w-[95%] py-4">
        <div className="flex flex-col items-start gap-10 min-w-[100%] flex-grow lg:flex-row md:gap-6 lg:gap-8">
          {/* Left side - Benefits */}
          <div className="w-full lg:w-[40%] flex items-start justify-start flex-col order-1">
            <Benefits discount="20" />
          </div>

          {/* Right side - CalCom */}
          <div className="w-full lg:w-[60%] order-2 px-4 h-fit">
            <CalComComponent />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
